<template>
    <v-card flat>
        <v-card-title>
            <s-toolbar dark color="#7b7b7b" label="Historial" close @close="$emit('close')"></s-toolbar>
        </v-card-title>

        <!-- Tarjeta con el estado actual de la tarea -->
        <v-card class="mx-4 my-2" outlined>
            <v-card-text>
                <div class="d-flex align-center">
                    <v-avatar color="primary" class="mr-3">
                        <v-icon dark>mdi-clipboard-text</v-icon>
                    </v-avatar>
                    <div class="flex-grow-1">
                        <div class="font-weight-bold text-h6">{{ item.TskTitle }}</div>
                        <div class="text-caption grey--text text--darken-1">{{ item.TskDescription }}</div>
                    </div>
                    <v-chip :color="item.TskStatusColor" small label>{{ item.TskStatusName }}</v-chip>
                </div>
            </v-card-text>
        </v-card>

        <v-card-text class="timeline-container">
            <v-timeline align-top dense>
                <v-timeline-item v-for="(entry, index) in data" :key="index" icon="mdi-emby" small>
                    <template class="timeline-date">
                        <div class="text-caption grey--text font-weight-bold mb-1">
                            <v-chip x-small color="warning">{{ $fun.formatTimeView(entry.SecCreate) }}</v-chip>
                        </div>
                    </template>
                    <v-card class="elevation-1 rounded-lg activity-card">
                        <v-card-text class="pa-3">
                            <div class="d-flex align-center">
                                <div class="flex-grow-1">
                                    <div class="font-weight-medium black--text">{{ entry.TskTitle }}</div>
                                    <div class="text-caption grey--text text--darken-1">
                                        {{ entry.TskDescription }}
                                    </div>
                                    
                                    <div v-if="getChanges(entry, index).length > 0" class="mt-2">
                                        <v-chip 
                                            v-for="(change, changeIndex) in getChanges(entry, index)" 
                                            :key="changeIndex"
                                            x-small
                                            class="mr-1 mb-1"
                                            color="purple lighten-3"
                                        >
                                            {{ change }}
                                        </v-chip>
                                    </div>
                                </div>
                                <div class="text-caption grey--text">
                                    <v-chip x-small color="#4FC3F7" dark>{{ $fun.formatDateView(entry.SecCreate) }}</v-chip>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-timeline-item>
            </v-timeline>
        </v-card-text>
    </v-card>
</template>


<script>
    import _sTaskService from '@/services/InformationTechnology/TaskService.js';

	export default {
		props: {
			item : {
                type: Object,
                default: () => {}
            },
        },
		data() {
			return {
				openDialog: false,
                data : [],
                config : {
                    headers: [
                        { text: 'Estado', value: 'Approval' },
                        { text: 'ID', value: 'RtkID' },
                        { text: 'Condición', value: 'RtkName' },
                        { text: 'Fecha Registro', value: 'RtkDate' }
                    ]
                },
			};
		},
		methods: {
            load(){
                _sTaskService.listHistory(this.item, this.$fun.getUserID())
                    .then(resp => {
                        if(resp.status == 200){
                            this.data = resp.data;
                            console.log( "data",this.data);
                        }
                    });
            },
            getChanges(currentEntry, index) {
                // Si es el primer elemento del historial, no hay cambios para comparar
                if (index === this.data.length - 1) {
                    return ["Registro inicial"];
                }
                
                // Obtener la entrada anterior para comparar
                const nextEntry = this.data[index + 1];
                // Lista para almacenar los cambios detectados
                const changes = [];
                
                // Campos a comparar (puedes personalizar esta lista)
                const fieldsToCompare = [
                    { field: 'TskTitle', label: 'Título' },
                    { field: 'TskDescription', label: 'Descripción' },
                    { field: 'TskStatusName', label: 'Estado' },
                    { field: 'TskPriorityName', label: 'Prioridad' },
                    { field: 'TypeClasificationName', label: 'Clasificación' },
                    { field: 'TskDateBeginName', label: 'Fecha inicio' },
                    { field: 'TskDateEndName', label: 'Fecha fin' },
                    { field: 'TkpTitle', label: 'Se tranfirió a' },
                    { field: 'TskDateTraslate', label: 'Fecha de transferencia' },
                ];
                
                // Comparar los campos y detectar cambios
                fieldsToCompare.forEach(item => {
                    if (currentEntry[item.field] !== nextEntry[item.field]) {
                        // Si el valor es null o undefined, asignar un string vacío para evitar errores
                        const oldValue = nextEntry[item.field] || '';
                        const newValue = currentEntry[item.field] || '';
                        
                        // Si ambos valores no son vacíos, registrar el cambio
                        if (oldValue || newValue) {
                            changes.push(`${item.label}: ${oldValue} → ${newValue}`);
                        }
                    }
                });
                
                // Si no se detectaron cambios en los campos principales, quizás fue un comentario
                if (changes.length === 0) {
                    changes.push("Actualización");
                }
                
                return changes;
            }
		},
        mounted() {
            console.log(this.item);
            this.load();
        },
	};
</script>

<style scoped>
.activity-card {
  background-color: white;
  border-radius: 8px;
  position: relative;
}

.timeline-container {
  background-color: #f5f5f5;
  padding: 16px;
}

.v-timeline-item__body::before,
.v-timeline-item__body::after,
.v-card::before,
.v-card::after {
  display: none !important;
}

.v-timeline-item__body .v-card::before,
.v-timeline-item__body .v-card::after {
  content: none !important;
}

.activity-card::before,
.activity-card::after {
  display: none !important;
  content: none !important;
}


.v-timeline-item {
  padding-bottom: 12px;
}

.v-timeline-item__body {
  margin-left: 12px;
}

.v-timeline::before {
  background-color: rgba(128, 128, 128, 0.2);
}
</style>